/** crash the browser tab by hijacking the thread */
export function mockMemoryLeakToCrashBrowserTab() {
  console.log("👩‍🔬 I hope you know what you're doing.");
  console.log("💣 browser tab will crash in 3, 2, 1...");

  //// crash the tab after 3 seconds
  //// so that we can click to another tab before crashing
  // setTimeout(() => {
  //   while (true) {}
  // }, 3 * 1000);

  // crash the tab
  // tslint:disable-next-line
  // eslint-disable-next-line no-constant-condition
  while (true) {
    // infinite loop -> block the main thread
  }
}
